'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { Container, Wrapper, ListJob } from './JobCardMiniList.css.js';
import JobCardMini from '../JobCardMini/index.js';
import { getSpecialJob, getJobYouWillLove } from './services.js';
import { ELanguage } from '../Utils/constants.js';

var JobCardMiniList = function (props) {
    var typeOptions = props.typeOptions, api = props.api, langCode = props.langCode, robot = props.robot, previewJob = props.previewJob, type = props.type, isMobile = props.isMobile, userInfo = props.userInfo;
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState([]), data = _b[0], setData = _b[1];
    var isLoading = (robot === null || robot === void 0 ? void 0 : robot.enable) ? false : loading;
    var listJob = (robot === null || robot === void 0 ? void 0 : robot.enable) ? robot === null || robot === void 0 ? void 0 : robot.data : data;
    var getJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, createdUtm, formatJobs, jobs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getJobYouWillLove({
                        baseUrl: api.baseUrl,
                        langCode: langCode,
                        query: __assign({ jobId: '0' }, api.query)
                    })];
                case 1:
                    data = (_a.sent()).data;
                    createdUtm = function (type, source) {
                        switch (type) {
                            case 'my-profile':
                                return "/?utm_source_navi=CareerCenter&utm_medium_navi=MyProfile&utm_campaign_navi=JobsYouWillLove&utm_content_navi=".concat(source, "&utm_term_navi=VB");
                            case 'job-detail':
                                return "/?utm_source_navi=jobalertemail&utm_medium_navi=JobDescription&utm_campaign_navi=PeopleAlsoView&utm_content_navi=".concat(source, "&utm_term_navi=VB");
                            case 'job-detail-right-corner':
                                return "/?utm_source_navi=jobdetail&utm_medium_navi=rightcorner&utm_campaign_navi=relevantjobs&utm_content_navi=".concat(source);
                            case 'event':
                                return "/?utm_source_navi=eventPage&utm_medium_navi=rightcorner&utm_campaign_navi=relevantjobs&utm_content_navi=".concat(source);
                            default:
                                return '';
                        }
                    };
                    formatJobs = data.jobs.map(function (item) {
                        var formatUtm = createdUtm('my-profile' , data.source);
                        var jobUrl = "".concat(item.alias, "-").concat(item.jobId).concat(langCode === ELanguage.EN ? '-jd' : '-jv').concat(formatUtm);
                        var locationText = (item.workingLocations || [])
                            .map(function (item) { return (langCode === ELanguage.VI ? item.cityNameVI : item.cityName); })
                            .join(', ');
                        var jobLevelText = langCode === ELanguage.VI ? item.jobLevelVI : item.jobLevel;
                        return __assign(__assign({}, item), { jobUrl: jobUrl, locationText: locationText, jobLevelText: jobLevelText });
                    });
                    if (!((api === null || api === void 0 ? void 0 : api.accessToken) && data.jobs.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSpecialJob({
                            baseUrl: api.baseUrl,
                            accessToken: api.accessToken,
                            jobs: formatJobs
                        })];
                case 2:
                    jobs = (_a.sent()).data;
                    setData(jobs);
                    return [3 /*break*/, 4];
                case 3:
                    setData(formatJobs);
                    _a.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getJobs();
    }, []);
    return (React__default.createElement(Container, { className: type }, !isLoading && (React__default.createElement(Wrapper, { className: 'jobs-section' },
        React__default.createElement(ListJob, { gridColumn: typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.gridColumn }, listJob.map(function (item, idx) { return (React__default.createElement(JobCardMini, { key: idx, isMobile: isMobile, item: item, langCode: langCode, api: api, previewJob: previewJob, userInfo: userInfo, isNldPage: true, initData: props.initData })); }))))));
};

export { JobCardMiniList as default };
//# sourceMappingURL=index.js.map
